import AdxEmptyState from 'components/reusable/emptyState/AdxEmptyState'
import { useQuery } from 'react-query'
import { getOneOrderHistory } from 'services/api/modules/recruitment/order'
import Tags from '../../recruitment-manage-applicant/components/Tags'
import AdxEmptyStateV2 from 'components/reusable/emptyState/AdxEmptyStateV2'

const { Dialog, Box, Typography, Icon, CircularProgress, CardMedia } = require('@mui/material')

const ViewListDialog = ({ open, handleClose, id }) => {
  // API CALL
  const {
    isLoading: orderIsLoading,
    error: orderError,
    data: orderData,
  } = useQuery(
    ['getOneOrderHistory', id],
    async () => {
      const { data } = await getOneOrderHistory(id)
      return data
    },
    {
      refetchOnWindowFocus: false,
    }
  )

  const CandidateCard = ({ profilePicture, name, price, hasVideo, rightComponent }) => {
    return (
      <Box
        display="flex"
        alignItems="center"
        columnGap={2}
        padding={2}
        sx={{
          borderBottom: '1px solid',
          borderBottomColor: 'gray-line.main',
        }}
      >
        <Box display="flex" alignItems="center" columnGap={2}>
          {profilePicture !== null ? (
            <CardMedia
              component="img"
              sx={{
                marginRight: 2,
                height: 45,
                width: 45,
                objectFit: 'cover',
                borderRadius: '50%',
              }}
              src={profilePicture}
            />
          ) : (
            <Box
              width={45}
              height={45}
              borderRadius="50%"
              bgcolor="alternate.main"
              color="white.main"
              marginRight={2}
              display="flex"
              alignItems="center"
              justifyContent="center"
              sx={{
                textTransform: 'capitalize',
              }}
            >
              {name.charAt(0)}
            </Box>
          )}
        </Box>
        <Box
          display="flex"
          flexDirection={{ xs: 'column', lg: 'row' }}
          rowGap={2}
          justifyContent="space-between"
          width={1}
        >
          <Box display="flex" alignItems="center" columnGap={2}>
            <Box width={200}>
              <Typography variant="body1" color="dark-text.main" marginBottom={0.5}>
                {name || 'No name'}
              </Typography>
              <Box display="flex" alignItems="center" columnGap={3}>
                {/* <Box display="flex" alignItems="center" columnGap={1}>
            
                <Typography
                  component="span"
                  variant="body2"
                  color="light-gray-text.main"
                >
                  Expires on {formattedDate}
                </Typography>
              </Box> */}
              </Box>
            </Box>

            <Box display="flex" columnGap={2}>
              <Tags typo="body1" icon="article" word="Resume" />
              {hasVideo ? <Tags typo="body1" icon="video_file" word="Video" /> : null}
            </Box>
          </Box>

          <Box display="flex" alignItems="center" columnGap={4} width={{ xs: 1, lg: 'auto' }}>
            {rightComponent ? (
              rightComponent
            ) : (
              <>
                <Box width={80}>
                  <Typography
                    variant="h4"
                    color="dark-text.main"
                    sx={{
                      fontWeight: 'bold',
                      textAlign: 'left',
                    }}
                  >
                    RM {price || '0'}.00
                  </Typography>
                </Box>
              </>
            )}
          </Box>
        </Box>
      </Box>
    )
  }
  if (orderIsLoading) {
    return (
      <Dialog open={open} onClose={handleClose}>
        <Box padding={2} display="flex" alignItems="center" justifyContent="space-between">
          <Typography
            variant="h4"
            sx={{
              fontWeight: 'bold',
            }}
          >
            Item
          </Typography>
          <Icon onClick={handleClose}>close_icon</Icon>
        </Box>
        <Box width={600} minHeight={600} display="flex" alignItems="center" justifyContent="center">
          <CircularProgress color="alternate" />
        </Box>
      </Dialog>
    )
  } else if (orderError !== null) {
    return (
      <Dialog open={open} onClose={handleClose}>
        <Box padding={2} display="flex" alignItems="center" justifyContent="space-between">
          <Typography
            variant="h4"
            sx={{
              fontWeight: 'bold',
            }}
          >
            Item
          </Typography>
          <Icon onClick={handleClose}>close_icon</Icon>
        </Box>
        <Box width={600} minHeight={600} display="flex" alignItems="center" justifyContent="center">
          <AdxEmptyStateV2 />
        </Box>
      </Dialog>
    )
  } else {
    return (
      <Dialog open={open} onClose={handleClose}>
        <Box width={600} minHeight={600}>
          <Box padding={2} display="flex" alignItems="center" justifyContent="space-between">
            <Typography
              variant="subtile1"
              sx={{
                fontWeight: 'bold',
              }}
            >
              Purchased candidate
            </Typography>
            <Icon onClick={handleClose}>close_icon</Icon>
          </Box>
          <Box minHeight={200}>
            <Box px={2} py={1} bgcolor="default-background.main">
              <Typography variant="subtitle2">{orderData?.length} Candidates</Typography>
            </Box>
            {orderData.map((list) => (
              <CandidateCard
                name={list.name}
                price={list.price}
                profilePicture={list.profile_image_url}
                hasVideo={list.has_video_interview}
              />
            ))}
          </Box>
        </Box>
      </Dialog>
    )
  }
}
export default ViewListDialog
